export default "__VITE_ASSET__Cw8hA5fJ__"